<script>
    import { currentPage } from './store';
    import Home from './Home.svelte';
    import Projects from './Projects.svelte';
    import Skills from './Skills.svelte';
    import Contact from './Contact.svelte';

    let page;
    currentPage.subscribe(value => {
        page = value;
    });

    const pages = {
        home: Home,
        projects: Projects,
        skills: Skills,
        contact: Contact,
    };

    let Component;
    $: Component = pages[page];
</script>

{#if Component}
    <svelte:component this={Component} />
{/if}